module.exports = __webpack_public_path__ + "img/symbol_16.0fb3853b.png";